import { DownloadConfigInfoType } from '../types';
import { sentimentNumber } from '../renderHelper/index';
import { indicatorsMap } from '@op/pages/Summary/constants';
import { formatDateFunc } from '@op/utils/time';

export const TopicTrackingTrends: DownloadConfigInfoType = {
  columns: ({ filter, auxiliaryParams }) => {
    const { tableHeader, indicators } = auxiliaryParams;

    const isRatio = ['mentions_ratio', 'negative_mentions'].includes(
      indicators,
    );
    let headerText = indicatorsMap[indicators];
    if (indicators === 'mentions_ratio') {
      headerText = 'Mentions';
    } else if (indicators === 'negative_mentions') {
      headerText = 'Negative Mentions';
    }

    function renderTotal(item: { [x: string]: any }, key: string | number) {
      if (indicators === 'sentiment') {
        return sentimentNumber(item, key);
      } 
      return item[key];
    }

    function renderTime(item: { [x: string]: any }, key: string | number) { 
      return formatDateFunc(filter.date_type)(item[key]);
    }

    function renderOther(item: { [x: string]: any }, key: string | number) { 
      return item[key];
    }

    const tableColumns: any = [
      {
        key: 'time',
        header: 'Time',
        fixed: 'left',
        renderHelper: [renderTime],
      },
      {
        key: 'total',
        align: 'right',
        header: headerText,
        renderHelper: [renderTotal],
      },
    ];

    tableHeader.forEach(({ title, key }: any) => {
      const column: any = {
        key,
        align: 'right',
        header: title,
        renderHelper: [renderOther],
      };
      if (isRatio) {
        column['numFmt'] = '0.00%';
      }
      if (indicators === 'sentiment') {
        column.renderHelper = [sentimentNumber];
      }
      tableColumns.push(column);
    });

    return tableColumns;
  }, 
};
